// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../engines/gameEngine";
import data_control from "../engines/libs/data_control";

const {ccclass, property} = cc._decorator;

const jsb = window.jsb;

@ccclass
export default class HotUpdate extends cc.Component {

    @property(cc.Label)
    lbTitle: cc.Label = null;
    @property(cc.Label)
    lbUpdate: cc.Label = null;
    @property(cc.ProgressBar)
    pbFile: cc.ProgressBar = null;
    @property(cc.ProgressBar)
    pbUpdate: cc.ProgressBar = null;

    @property(cc.Asset)
    manifestUrl: cc.Asset = null!;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start() {
        this.onCheckVersion();
    }

    private _updateListener = null;
    private _updating = false;
    private _storagePath = '';
    private _am: jsb.AssetsManager = null;
    private _failCount = 0;
    private versionCompareHandle: (versionA: string, versionB: string) => number = null!;

    protected onCheckVersion() {
        //非JSB环境
        if (!jsb) {
            return;
        }
        this._storagePath = ((jsb.fileUtils ? jsb.fileUtils.getWritablePath() : '/') + 'blackjack-remote-asset');
        console.log('Storage path for remote asset : ' + this._storagePath);

        this.versionCompareHandle = function (versionA: string, versionB: string) {
            console.log("JS Custom Version Compare: version A is " + versionA + ', version B is ' + versionB);
            let vA = versionA.split('.');
            let vB = versionB.split('.');
            for (let i = 0; i < vA.length; ++i) {
                let a = parseInt(vA[i]);
                let b = parseInt(vB[i] || '0');
                if (a === b) {
                    continue;
                } else {
                    return a - b;
                }
            }
            if (vB.length > vA.length) {
                return -1;
            } else {
                return 0;
            }
        };

        // Init with empty manifest url for testing custom manifest
        this._am = new jsb.AssetsManager('', this._storagePath, this.versionCompareHandle);

        // Setup the verification callback, but we don't have md5 check function yet, so only print some message
        // Return true if the verification passed, otherwise return false
        this._am.setVerifyCallback((path: string, asset: any) => {
            // When asset is compressed, we don't need to check its md5, because zip file have been deleted.
            let compressed = asset.compressed;
            // Retrieve the correct md5 value.
            let expectedMD5 = asset.md5;
            // asset.path is relative path and path is absolute.
            let relativePath = asset.path;
            // The size of asset file, but this value could be absent.
            let size = asset.size;
            if (compressed) {
                this.lbUpdate.string = "验证通过 : " + relativePath;
                return true;
            } else {
                this.lbUpdate.string = "验证通过 : " + relativePath + ' (' + expectedMD5 + ')';
                return true;
            }
        });

        this.lbUpdate.string = '正在检查版本信息';
        this.pbFile.progress = 0;
        this.pbUpdate.progress = 0;
        this.checkUpdate();
    }

    protected checkCb(event: any) {
        console.log('Code: ' + event.getEventCode());
        let jumpUpdate = false;
        switch (event.getEventCode()) {
            case jsb.EventAssetsManager.ERROR_NO_LOCAL_MANIFEST:
                this.lbUpdate.string = "未找到本地版本文件，即将跳过更新";//No local manifest file found, hot update skipped.";
                jumpUpdate = true;
                break;
            case jsb.EventAssetsManager.ERROR_DOWNLOAD_MANIFEST:
            case jsb.EventAssetsManager.ERROR_PARSE_MANIFEST:
                this.lbUpdate.string = "更新版本信息加载失败，即将跳过更新";//Fail to download manifest file, hot update skipped.";
                jumpUpdate = true;
                break;
            case jsb.EventAssetsManager.ALREADY_UP_TO_DATE:
                this.lbUpdate.string = '已是最新版本';//"Already up to date with the latest remote version.";
                O1HD.loadScene('loading');
                break;
            case jsb.EventAssetsManager.NEW_VERSION_FOUND:
                this.lbUpdate.string = '检查到新版本，即将自动更新 (' + data_control.getMemoryNumber(this._am.getTotalBytes()) + ')';
                this.scheduleOnce(() => {
                    this.hotUpdate();
                }, 1.5);
                this.pbFile.progress = 0;
                this.pbUpdate.progress = 0;
                break;
            default:
                return;
        }
        if (jumpUpdate) {
            this.scheduleOnce(() => {
                O1HD.loadScene('loading');
            }, 1.5);
        }

        this._am.setEventCallback(null!);
        // this._checkListener = null;
        this._updating = false;
    }

    protected checkUpdate() {
        if (this._updating) {
            this.lbUpdate.string = '正在检查或更新...';
            return;
        }
        if (this._am.getState() === jsb.AssetsManager.State.UNINITED) {
            let url = this.manifestUrl.nativeUrl;
            console.log('结果地址2', url);
            this._am.loadLocalManifest(url);
        }
        if (!this._am.getLocalManifest() || !this._am.getLocalManifest().isLoaded()) {
            this.lbUpdate.string = '加载本地版本文件失败...';
            return;
        }
        this._am.setEventCallback(this.checkCb.bind(this));

        this._am.checkUpdate();
        this._updating = true;
    }


    protected hotUpdate() {
        if (this._am && !this._updating) {
            this._am.setEventCallback(this.updateCb.bind(this));

            if (this._am.getState() === jsb.AssetsManager.State.UNINITED) {
                let url = this.manifestUrl.nativeUrl;
                console.log('结果地址', url);
                this._am.loadLocalManifest(url);
            }

            this._failCount = 0;
            this._am.update();
            this._updating = true;
        }
    }

    updateCb(event: any) {
        let needRestart = false;
        let failed = false;
        switch (event.getEventCode()) {
            case jsb.EventAssetsManager.ERROR_NO_LOCAL_MANIFEST:
                this.lbUpdate.string = '未匹配到本地版本文件，即将跳过更新';//'No local manifest file found, hot update skipped.';
                failed = true;
                break;
            case jsb.EventAssetsManager.UPDATE_PROGRESSION:
                this.pbUpdate.progress = event.getPercent();
                this.pbFile.progress = event.getPercentByFile();

                this.lbUpdate.string = event.getDownloadedFiles() + ' / ' + event.getTotalFiles();
                // this.panel.byteLabel.string = event.getDownloadedBytes() + ' / ' + event.getTotalBytes();
                // console.log(this.panel.fileLabel.string, this.panel.byteLabel.string);
                let msg = event.getMessage();
                if (msg) {
                    this.lbUpdate.string = '更新文件:' + msg;
                    // cc.log(event.getPercent()/100 + '% : ' + msg);
                }
                break;
            case jsb.EventAssetsManager.ERROR_DOWNLOAD_MANIFEST:
            case jsb.EventAssetsManager.ERROR_PARSE_MANIFEST:
                this.lbUpdate.string = '远程版本匹配加载失败，即将跳过更新';//'Fail to download manifest file, hot update skipped.';
                failed = true;
                break;
            case jsb.EventAssetsManager.ALREADY_UP_TO_DATE:
                this.lbUpdate.string = '已匹配最新远程版本';
                failed = true;
                break;
            case jsb.EventAssetsManager.UPDATE_FINISHED:
                this.lbUpdate.string = '更新成功 ' + event.getMessage();
                needRestart = true;
                break;
            case jsb.EventAssetsManager.UPDATE_FAILED:
                this.lbUpdate.string = '更新失败 ' + event.getMessage();
                this._updating = false;
                break;
            case jsb.EventAssetsManager.ERROR_UPDATING:
                this.lbUpdate.string = '资源更新出错: ' + event.getAssetId() + ', ' + event.getMessage();
                break;
            case jsb.EventAssetsManager.ERROR_DECOMPRESS:
                this.lbUpdate.string = event.getMessage();
                break;
            default:
                break;
        }

        if (failed) {
            this._am.setEventCallback(null!);
            this._updateListener = null;
            this._updating = false;
        }

        if (needRestart) {
            this._am.setEventCallback(null!);
            this._updateListener = null;
            // Prepend the manifest's search path
            let searchPaths = jsb.fileUtils.getSearchPaths();
            let newPaths = this._am.getLocalManifest().getSearchPaths();
            console.log(JSON.stringify(newPaths));
            Array.prototype.unshift.apply(searchPaths, newPaths);
            // This value will be retrieved and appended to the default search path during game startup,
            // please refer to samples/js-tests/main.js for detailed usage.
            // !!! Re-add the search paths in main.js is very important, otherwise, new scripts won't take effect.
            localStorage.setItem('HotUpdateSearchPaths', JSON.stringify(searchPaths));
            jsb.fileUtils.setSearchPaths(searchPaths);

            // restart game.
            setTimeout(() => {
                cc.game.restart();
            }, 1000)
        }
    }

    // update (dt) {}
}
